module.exports = __webpack_public_path__ + "img/img82.6a6393c0.png";